/**
 * DevExtreme (esm/__internal/scheduler/workspaces/const.js)
 * Version: 24.1.6
 * Build date: Sat Sep 14 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const WORK_SPACE_BORDER_PX = 1;
